import React from 'react';
import './GoogleReview.css';

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Meggan',
      text: 'I\'ve gotten several items altered here over the years including my wedding dress. Their attention to detail and quality of work is outstanding! Very fair and honest pricing. For my wedding dress they even wanted to give me some money back because it wasn\'t as many bustles as they originally thought. My dress turned out better than I could have imagined! I would trust them with anything at this point. Very kind and honest people own this place. I highly recommend!',
      rating: 5,
    },
    {
      name: 'Katrina',
      text: 'Fantastic service at a great price. Have used this place several times now and I\'m always happy with the results, even for my unusual jobs.',
      rating: 5,
    },
    {
      name: 'Dwight',
      text: 'Great experience and exceptional service. I get all my alterations done here and the work always looks fantastic.',
      rating: 5,
    },
    {
      name: 'Jace',
      text: 'Took my son\'s hoodie in to repair the pocket. Picked up the next day. Price was fantastic, service was great.',
      rating: 5,
    },
    {
      name: 'Christian',
      text: 'They did an absolutely incredible job on my wife\'s wedding dress, they did it for a reasonable price, and they did it very quickly after everyone else in the area said they couldn\'t do it at all. This place is incredible.',
      rating: 5,
    },
  ];

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, i) => (
      <i key={i} className="fas fa-star"></i>
    ));
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <h2>Reviews</h2>
          <p>Real reviews from our satisfied customers</p>
          <div className="google-rating-summary">
            <i className="fab fa-google"></i>
            <span className="rating-score">4.7</span>
            <div className="rating-stars">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star-half-alt"></i>
            </div>
            <span className="review-count">45 Google Reviews</span>
          </div>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-quote">
                <i className="fas fa-quote-left"></i>
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-rating">
                {renderStars(testimonial.rating)}
              </div>
              <div className="testimonial-author">
                <span className="author-name">{testimonial.name}</span>
                <span className="review-source">
                  <i className="fab fa-google"></i> Google Review
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
